import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddReportImgRes;
export const AddReportImgTodo = createAsyncThunk('AddReportImg', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/detects_cells_test',
            data: data,
            headers: { "Content-Type": "multipart/form-data",  "Authorization": 'Bearer ' + localStorage.getItem('user_token')}
        })
        return AddReportImgRes = res.data
        
    } catch (error) {
        return AddReportImgRes = error.response.data
    }
})